import { pipe } from "fp";

import { creator, effects, reducer, type } from "~/Action/Definition";

import { Action } from "~/Messaging";

import * as Active from "./Active";

export namespace Updated {
  export const { TYPE, create, reduce } = pipe(
    type("Active Messages Updated" as const),
    creator((active: Active.Active) => ({ active })),
    reducer(
      ({ state, action: { active } }) =>
        (state.messages.active = active as typeof state.messages.active)
    ),
    effects(({ dispatch, action: { active } }) =>
      active ? dispatch(Action.Requested.create(active)) : undefined
    )
  );
}

export namespace Cleared {
  export const { TYPE, create, reduce } = pipe(
    type("Active Messages Cleared" as const),
    reducer(({ state }) => {
      state.messages.active = undefined;
    })
  );
}
